export default __webpack_public_path__ + "static/media/lava-ui-laptop-main.d1992fd1.webp";